import { EonUiInput } from "@eon-ui/eon-ui-components-react";

const OnboardingPortalSearchFilter = ({
    t,
    search,
    setSearch,
    placeholder
}: {
    t: (key: string) => string;
    search: string;
    setSearch: (value: string) => void;
    placeholder?: string
}) => {
    return (
        <EonUiInput
            placeholder={placeholder || t("onboardingPortal.tableHeaders.search")}
            trailingIconName="search"
            type="search"
            size="small"
            value={search}
            onValueChanged={(e) => setSearch(e.target.value)}
        />
    );
};

export default OnboardingPortalSearchFilter;